const TeamDetails = () =>
  import(/* webpackChunkName: "TeamViews" */ '../views/team/TeamDetails.vue');
const TeamMembersTab = () =>
  import(
    /* webpackChunkName: "TeamViews" */ '../views/team/TeamMembersTab.vue'
    );
const TeamTicketsTab = () =>
  import(
    /* webpackChunkName: "TeamViews" */ '../views/team/TeamTicketsTab.vue'
    );
const CreateVirtualTeam = () =>
  import(
    /* webpackChunkName: "TeamViews" */ '../views/team/CreateVirtualTeam.vue'
    );
const EditVirtualTeam = () =>
  import(
    /* webpackChunkName: "TeamViews" */ '../views/team/EditVirtualTeam.vue'
    );

export const routeTeam = [
  {
    path: 'team/:id',
    name: 'TeamDetails',
    component: TeamDetails,
    children: [
      {
        path: 'members',
        name: 'TeamMembersTab',
        component: TeamMembersTab,
        meta: {
          title: 'Team members'
        }
      },
      {
        path: 'improves',
        name: 'TeamTicketsTab',
        component: TeamTicketsTab,
        meta: {
          title: 'Team - Ideas'
        }
      }
    ],
    redirect: 'team/:id/improves'
  },
  {
    path: 'team/virtual/create',
    name: 'CreateVirtualTeam',
    component: CreateVirtualTeam,
    meta: {
      title: 'New team'
    }
  },
  {
    path: 'team/virtual/:id',
    name: 'EditVirtualTeam',
    component: EditVirtualTeam,
    meta: {
      title: 'Edit team'
    }
  }
];
